// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"i0","controlPlay":"i1","controlElement":"i2","lowerControlWrapper":"i3","lowerControlIconWrapper":"i4","lowerControlIcon":"i5","show":"i6"};